import { keepPreviousData, useQuery } from '@tanstack/react-query';

import getTaskHistory from 'Api/host-presence-content/getTaskHistory';
import getTaskHistoryRequest from './model/request/getTaskHistoryRequest';
import getTaskHistoryResponse from './model/response/getTaskHistoryResponse';

import { useHostPresenceContentState } from 'View/host-presence-content/state';

const useGetTaskHistory = ({ params }) => {
  const { state, updateState } = useHostPresenceContentState();

  return useQuery({
    queryKey: ['host-task-history', params],
    queryFn: async () => {
      const queries = getTaskHistoryRequest(params);

      const response = await getTaskHistory(queries);

      const result = getTaskHistoryResponse(response, state.previousTaskHistory, params?.page);

      updateState({ previousTaskHistory: result?.tasks });

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    placeholderData: keepPreviousData,
  });
};

export default useGetTaskHistory;
